import {Spinner, TextInput} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import Div from '../../components/Div.styled';
import EmptyResult from '../../components/EmptyResults';
import Icon from '../../components/Icon';
import SpaceLike from '../../components/Space';
import InputWrapperWithLabel from '../../components/StyledInputWrapperWithLabel';
import TypographyBody from '../../components/Typography/TypographyBody';
import {convertDataForQuestionManualOne} from '../../helpers/questionManualTransformData';
import {
  QuestionManualContent,
  Result,
  SelectManualProps,
} from '../../types/questionManuals';
import {config} from '../../environment';

type QuestionManualOneProps = {
  handleNextStep: () => void;
  currentQuestion: QuestionManualContent;
  handleSelect: (data: SelectManualProps) => void;
};

export interface TransformedData {
  key: number | string;
  option: string | string[];
  makecode: string | string[];
}

export default function QuestionManualOne({
  handleNextStep,
  currentQuestion,
  handleSelect,
}: QuestionManualOneProps) {
  const [value, setValue] = React.useState('');
  const [filteredData, setFilteredData] = React.useState<Result[]>([]);
  const [data, setData] = React.useState<Result[]>([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const fetchState = async () => {
      try {
        const brandsResponse = await fetch(`${config.API_REDBOOK_BRANDS_URL}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const response = await brandsResponse.json();
        const responseData: Result[] = convertDataForQuestionManualOne(
          response.data,
        );
        setData(responseData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchState();
  }, []);
  React.useEffect(() => {
    if (data && data.length > 0) {
      const currentData = [...data];
      const lowercasedInput = value.toLowerCase();
      const filteredArray = currentData.map((item) => {
        const filteredOptions = item.option.filter((option) =>
          option.description.toLowerCase().includes(lowercasedInput),
        );
        return {
          key: item.key,
          option: filteredOptions.length > 0 ? filteredOptions : [],
        };
      });

      const finalFilteredArray = filteredArray.filter(
        (item) => item.option.length > 0,
      );
      setFilteredData(finalFilteredArray);
    }
  }, [data, value]);

  function handleInputChange(e: React.SyntheticEvent<HTMLInputElement>) {
    const target = e.target as HTMLInputElement;
    const inputValue = target.value;
    setValue(inputValue);
  }

  return (
    <>
      <Div width="100%">
        <InputWrapperWithLabel>
          <TextInput
            appearance={'default'}
            placeholder="Start typing your make"
            value={value}
            onChange={(event) => handleInputChange(event)}
            label="Vehicle Make"
            hasClearButton
            isClearButtonVisible
            onClear={() => {
              setValue('');
              setFilteredData([...filteredData]);
            }}
            clearIconLabel="Clear search"
          />
        </InputWrapperWithLabel>
      </Div>
      <SpaceLike
        direction="vertical"
        size={40}
        customStyles={{
          marginTop: 40,
        }}
        className="no-scroll"
        width={'100%'}
      >
        {currentQuestion.suggest
          ?.toLocaleLowerCase()
          .includes(value.toLocaleLowerCase()) && (
          <Div customStyles={{color: 'white'}}>
            <TypographyBody style={{margin: '0 0 16px', fontSize: 20}}>
              Suggested makes
            </TypographyBody>
            <SpaceLike
              direction="vertical"
              size={16}
              onClick={() => {
                handleSelect({
                  value: currentQuestion.suggest || '',
                  id: currentQuestion.id || '',
                  makeCode: 'VOLK',
                  vehicletype: 'PS, LC',
                });
                handleNextStep();
              }}
              customStyles={{cursor: 'pointer'}}
            >
              <TypographyBody
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  margin: 0,
                  fontSize: 16,
                }}
              >
                {currentQuestion.suggest}
                <Icon icon="arrow-right-alt" color="white" />
              </TypographyBody>
            </SpaceLike>
          </Div>
        )}
        {loading ? (
          <Div width="100%" customStyles={{textAlign: 'center'}}>
            <Spinner variant="large" />
          </Div>
        ) : filteredData?.length > 0 ? (
          filteredData.map((item, index) => {
            return (
              <Div key={index} customStyles={{color: 'white'}}>
                <TypographyBody style={{margin: '0 0 16px', fontSize: 20}}>
                  {item.key}
                </TypographyBody>
                <SpaceLike direction="vertical" size={16}>
                  {Array.isArray(item.option) &&
                    item.option?.map((option, i) => {
                      return (
                        <TypographyBody
                          key={i}
                          onClick={() => {
                            handleSelect({
                              value: option.description || '',
                              id: currentQuestion.id || '',
                              makeCode: option.makeCode || '',
                              vehicletype: option.vehicletype || '',
                            });
                            handleNextStep();
                          }}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            margin: 0,
                            fontSize: 16,
                            cursor: 'pointer',
                          }}
                        >
                          {option.description}
                          <Icon
                            icon="arrow-right-alt"
                            color="white"
                            style={{cursor: 'pointer'}}
                          />
                        </TypographyBody>
                      );
                    })}
                </SpaceLike>
              </Div>
            );
          })
        ) : (
          <EmptyResult />
        )}
      </SpaceLike>
    </>
  );
}
